import css from 'styled-jsx/css';

export default css`:global(em) {
  color: white; }

h2 {
  font-size: 24px;
  font-weight: 500;
  line-height: 1.42;
  letter-spacing: 0.4px;
  text-align: center;
  color: #414141;
  margin-bottom: 64px;
  position: relative;
  margin-top: 160px; }

h2:after {
  content: '';
  display: block;
  width: 48px;
  height: 8px;
  background-color: #414141;
  border-radius: 4px;
  position: absolute;
  left: 50%;
  top: 50px;
  transform: translateX(-50%); }

.creatorResource {
  z-index: 1;
  margin-top: 60px;
  position: relative;
  overflow: hidden;
  height: 800px; }
  @media only screen and (max-width: 500px) {
    .creatorResource {
      height: auto; } }
  .creatorResource .circle1 {
    width: 168px;
    height: 168px;
    background-color: #d9c5ff;
    position: absolute;
    border-radius: 168px;
    top: 60px;
    transform: translateX(-50%); }
    @media only screen and (max-width: 500px) {
      .creatorResource .circle1 {
        display: none; } }
  .creatorResource .circle2 {
    width: 346px;
    height: 346px;
    background-color: #d9c5ff;
    position: relative;
    border-radius: 346px;
    top: 75%;
    transform: translate(-35%, -50%);
    left: 100%; }
    @media only screen and (max-width: 500px) {
      .creatorResource .circle2 {
        display: none; } }
  .creatorResource .text {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%); }
    @media only screen and (max-width: 500px) {
      .creatorResource .text {
        width: 100%;
        position: relative; } }
    .creatorResource .text h2 {
      margin-top: 0; }
    .creatorResource .text .boxwrap {
      width: 702px;
      display: flex;
      margin: auto; }
      @media only screen and (max-width: 500px) {
        .creatorResource .text .boxwrap {
          display: block;
          width: auto; } }
      .creatorResource .text .boxwrap .box {
        width: 343px;
        background-color: #fff;
        margin: 16px;
        border-radius: 8px;
        position: relative; }
        @media only screen and (max-width: 500px) {
          .creatorResource .text .boxwrap .box {
            width: 95%;
            max-width: 343px;
            margin: 16px auto; } }
        .creatorResource .text .boxwrap .box h3 {
          position: absolute;
          top: 175px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 20px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.7;
          letter-spacing: 0.33px;
          text-align: center;
          color: #414141; }
        .creatorResource .text .boxwrap .box .img {
          height: 343px;
          margin: auto; }
          .creatorResource .text .boxwrap .box .img img {
            width: 100%; }
        .creatorResource .text .boxwrap .box p {
          width: 228px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 12px;
          color: #6d6d6d;
          line-height: 1.5;
          letter-spacing: 0.4px;
          text-align: center;
          top: 220px;
          position: absolute; }
`